module.exports = __webpack_public_path__ + "fonts/AvenirNextLTPro-Bold.91d8ff8a.otf";